var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgChatImagei = function SvgChatImagei(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M15.947 16.367H8.053A1.056 1.056 0 0 1 7 15.315V9.052a1.056 1.056 0 0 1 1.053-1.053h7.894A1.056 1.056 0 0 1 17 9.052v6.263a1.056 1.056 0 0 1-1.053 1.052m-1.526-.789h1.526a.264.264 0 0 0 .263-.263V14.17l-1.51-.829-1.763.737zm-6.632-2.632v2.382a.264.264 0 0 0 .263.263h5.264l-3.777-3.816zm1.8-2.066a.36.36 0 0 1 .279.119l2.461 2.474 2.237-.934a.44.44 0 0 1 .342.013l1.3.724V9.052a.264.264 0 0 0-.261-.264H8.053a.264.264 0 0 0-.263.263v2.948l1.592-1.053a.33.33 0 0 1 .21-.065zm3.25.961a1 1 0 1 1 1-1 1 1 0 0 1-.997 1zm0-1.2a.21.21 0 0 0-.211.211c0 .224.408.224.408 0a.19.19 0 0 0-.194-.208z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChatImagei);
export default ForwardRef;